import { defineMessages } from 'react-intl'

const baseId = 'appointment_wait_times_filter'

export default defineMessages({
  title: {
    id: `${baseId}.title`,
    defaultMessage: 'Consumer network',
  },
})
